import React from 'react';
import { useNavigate, useLocation, useParams } from 'react-router-dom';

/**
 * Higher Order Component to provide React Router v7 functionality to class components
 * This replaces the old withRouter HOC from React Router v5
 */
export const withRouter = (Component) => {
  const WrappedComponent = (props) => {
    const navigate = useNavigate();
    const location = useLocation();
    const params = useParams();

    // Create a history-like object for backward compatibility
    const history = {
      push: (path, state) => {
        try {
          // Ensure path is a string and handle any potential issues
          const targetPath = typeof path === 'string' ? path : String(path);
          navigate(targetPath, { state });
        } catch (error) {
          console.error('Navigation error:', error);
          // Fallback to window.location for problematic navigations
          window.location.href = path;
        }
      },
      replace: (path, state) => {
        try {
          const targetPath = typeof path === 'string' ? path : String(path);
          navigate(targetPath, { replace: true, state });
        } catch (error) {
          console.error('Navigation replace error:', error);
          window.location.replace(path);
        }
      },
      goBack: () => {
        try {
          navigate(-1);
        } catch (error) {
          console.error('Go back error:', error);
          window.history.back();
        }
      },
      goForward: () => {
        try {
          navigate(1);
        } catch (error) {
          console.error('Go forward error:', error);
          window.history.forward();
        }
      },
      go: (n) => {
        try {
          navigate(n);
        } catch (error) {
          console.error('Go error:', error);
          window.history.go(n);
        }
      },
      length: window.history.length,
      action: 'POP', // This is a simplified approach
      location,
      block: () => {
        console.warn('history.block is not supported in React Router v7');
      },
      listen: () => {
        console.warn('history.listen is not supported in React Router v7');
      },
    };

    return (
      <Component
        {...props}
        history={history}
        location={location}
        navigate={navigate}
        params={params}
      />
    );
  };

  // WrappedComponent.displayName = `withRouter(${Component.displayName || Component.name})`;
  
  return WrappedComponent;
};

export default withRouter; 